import React from 'react';
import MobileLayout from './MobileLayout';

const Layout = ({ children }) => {
  // Use responsive layout for all screen sizes
  return <MobileLayout>{children}</MobileLayout>;
};

export default Layout;